var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('the-breadcrumbs'),_c('page-content',{attrs:{"page-title":"QR-Code bearbeiten"}},[_c('qr-code-form',{attrs:{"loading":_vm.loading,"qr-code":_vm.qrCode,"form-submitted":_vm.saveQrCode,"mode":"edit"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }